<template>
  <div class="main-view news-container">
		<div class="bg-container news-hero ">
			<h1>Here's what's sprouting</h1>
			<bg-wave-element></bg-wave-element>
		</div>
		
		<section class="flex-row template-inner">
			<h2>In the news</h2>
			<h2>Press Releases</h2>
		</section>
		<Demo />
  </div>
</template>

<script>
	import Demo from '@/components/Demo.vue'


	export default {
		name: 'news',
		components: {
			Demo
		}
	}
</script>

<style lang="stylus" scoped>
	.news-container 
		margin-top 117px

	.news-hero
		background url('~@/assets/img/bgs/news-hero.jpg') center top / cover no-repeat #fff
		padding 100px 0 240px
		position relative
		
		h1 
			color white
			font-size 85px
			text-align  center

	// @media ( min-width: 1725px ) 
	// 	.news-hero
	// 		background url('~@/assets/img/bgs/news-hero.jpg') center bottom / cover no-repeat #fff
			




</style>